import React from "react";

export const PineappleCoconutCrispSection = React.memo(() => {
  return (
    <img
      title="杏鳳椰酥"
      alt="杏鳳椰酥"
      aria-label="杏鳳椰酥"
      src={require("assets/pineapple-coconut-crisp.jpg")}
    />
  );
});
